import React, { Component } from 'react'
import {Modal,Row,Col,Button,Input,notification,Icon,Tooltip} from "antd";

import './style.less'

// components
import {ImgUpload, DownloadModal} from 'marmot_design_ui'

// model
import NoticeDetails from '../../model/noticeDetails'
// img
import PDFIcon from '@/assets/image/head/pdf.svg'
import WordIcon from '@/assets/image/head/word.svg'
import ExcelIcon from '@/assets/image/head/excel.svg'
import ConfirmReadIcon from '@/assets/image/head/confirmRead.svg' 
import AnswerIcon from '@/assets/image/answer.svg'
import AttachmentIcon from '@/assets/image/atachment.svg'
import ReplayIcon from '@/assets/image/replay.svg'

interface iProps {
    onCancel: () => void;
    visible: boolean;
    noticeDetails: NoticeDetails,
    readCallback: () => void,
    readBtnStatus: boolean,
    answerCallback: (answerContent: string) => void
}
const { TextArea } = Input
export default class noticeDetails extends Component<iProps> {
    state= {
        fileList: [],
        downloadUrl: '',
        downloadName: '',
        downloadModalVisible: false
    }
    onOk = () => {
        this.props.readCallback()
    };
    answer = () => {
        if (this.refs.answerContent['state'].value.trim()) {
            this.props.answerCallback(this.refs.answerContent['state'].value)
        } else {
            notification['warning']({
                message: '请输入回复内容',
                duration: 1
            })
        }
    }
    getFileList = (fileList) => {}
    downloadFile = async (downloadName, downloadUrl) => {
        await this.setState({downloadName, downloadUrl})
        this.setState({downloadModalVisible: true})
    }
    render() {
        const { visible, onCancel, noticeDetails, readBtnStatus } = this.props
        let { downloadUrl, downloadName, downloadModalVisible } = this.state
        const statusStyle = {
            backgroundColor: noticeDetails.levelColor || '#000',
            borderColor: noticeDetails.levelColor || '#000',
            color: '#fff'
        }
        return (
            <Modal
            width="952px"
            title="通知详情"
            visible={visible}
            footer={null}
            onCancel={onCancel}
            className="noticeDetails"
            style={{padding: 0}}
            >
                <div className="noticeDetails_content">
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <span className="boldTitle noticeDetails_title">{noticeDetails.title}</span>
                            {noticeDetails.levelName && noticeDetails.levelName !== '默认' &&<span className="ml12 mr8 noticeDetails_level" style={statusStyle}>{noticeDetails.levelName}</span>}
                            {noticeDetails.attachmentFlag && 
                            <Tooltip placement="bottom" title="附件">
                            <span className="noticeDetails_icon noticeDetails_clipicon"><img src={AttachmentIcon}/></span>
                            </Tooltip>}
                            {
                                noticeDetails.needAnswerFlag && 
                                <Tooltip placement="bottom" title="需要回复">
                                <span className="noticeDetails_icon noticeDetails_answericon"><img src={AnswerIcon}/></span>
                                </Tooltip>
                            }
                            {
                                !noticeDetails.needAnswerFlag && noticeDetails.needReplayFlag && 
                                <Tooltip placement="bottom" title="需要确认">
                                <span className="noticeDetails_icon noticeDetails_replayicon"><img src={ReplayIcon}/></span>
                                </Tooltip> 
                            }
                            {
                                noticeDetails.needFormFlag && 
                                <Tooltip placement="bottom" title="表单填报">
                                    <span className="noticeDetails_icon receiveTable_fillform">
                                        <img src="https://bs-application-resource.oss-cn-beijing.aliyuncs.com/app/notice/fillform.svg" />
                                    </span>
                                </Tooltip> 
                            }
                        </div>
                        {noticeDetails.needReplayFlag && !noticeDetails.needAnswerFlag && 
                        <div className="noticeDetails_confirmread">
                            <div>
                                <img src={ConfirmReadIcon} />
                            </div>
                            <div className="ml8">该通知要求已读确认！</div>
                        </div>}
                    </div>
                    <div className="mt8 noticeDetails_send">
                        <span>{noticeDetails.sendTime}</span>
                        <span className="ml24">
                            {noticeDetails.noticeType === 'SCHOOL' ? '校级通知' : (noticeDetails.noticeType === 'CLASS' ? '班级通知' : (noticeDetails.noticeType === 'GRADE' ?  '年级通知' : noticeDetails.noticeType === 'TEACHING_CLASS' ? '教学班通知' : ''))}
                            {noticeDetails.categoryName && <span>-{noticeDetails.categoryName}</span>}
                        </span>
                    </div>
                    <div className="mt8 noticeDetails_send">
                        <span>发布人：{noticeDetails.sendUser.fullName}</span>
                    </div>
                    <div className="mt16">
                        <div className="boldTitle noticeDetails_sec_title">通知内容：</div>
                        <div className="mt8" 
                            dangerouslySetInnerHTML={{__html: noticeDetails.content}}>
                        </div>
                    </div>
                    <div className="mt16">
                        <Row>
                            <Col span={24}>
                                <div className="boldTitle noticeDetails_sec_title">附件：</div>
                            </Col>
                            <Col span={23} push={1} className="mb16">
                                {
                                    noticeDetails.imageAttachments && noticeDetails.imageAttachments.length !== 0
                                    && <div>
                                            <ImgUpload upload={false} fileList={noticeDetails.imageAttachments}></ImgUpload>
                                            <div className="noticeDetails_imglist">
                                                {
                                                    noticeDetails.imageAttachments.map(item => {
                                                        return <div className="noticeDetails_imgitem">
                                                            <div className="noticeDetails_imgitem_name">
                                                                {item.name}
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                }
                            </Col>
                            <Col span={23} push={1}>
                                <div className="noticeDetails_filelist">
                                    {
                                        noticeDetails.fileAttachments && noticeDetails.fileAttachments.map(item => {
                                            return <a href={item.fileUrl} target="_black" className="noticeDetails_fileitem">
                                                        <div className="noticeDetails_fileitem_img">
                                                            {
                                                                (item.contentType === 'application/msword' || item.contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                                                                && <img src={WordIcon}/> 
                                                            }
                                                            {
                                                                (item.contentType ==='application/vnd.ms-excel application/x-excel' ||
                                                                    item.contentType ==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'||
                                                                    item.contentType === 'application/vnd.ms-excel')
                                                                && <img src={ExcelIcon}/> 
                                                            }
                                                            {
                                                                item.contentType === 'application/pdf'
                                                                && <img src={PDFIcon}/> 
                                                            }
                                                        </div>
                                                        <div className="noticeDetails_fileitem_name">{item.name}</div>
                                                    </a>
                                        })
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {noticeDetails.needAnswerFlag &&
                <>
                    {!noticeDetails.answerContent && 
                    <div className="noticeDetails_answer">
                        <div className="noticeDetails_answer_title">回复内容：</div>
                        <div className="noticeDetails_answer_content">
                            <TextArea ref="answerContent" rows={3} placeholder="请输入回复内容" />
                        </div>
                        <div className="noticeDetails_answer_btn">
                            <Button type="primary" onClick={this.answer}>回复</Button>
                        </div>
                    </div>}
                    {
                        noticeDetails.answerContent && <>
                        <div className="noticeDetails_answer_content_already">回复内容：{noticeDetails.answerContent}</div>
                        </>
                    }
                </>}
                <div className="noticeDetails_footer">
                    <div className="noticeDetails_operate">
                        <Button onClick={onCancel}>关闭</Button>
                        {!noticeDetails.needAnswerFlag && noticeDetails.needReplayFlag &&
                            <Button disabled={readBtnStatus} type="primary" onClick={this.onOk}>已读</Button>}
                    </div>
                </div> 
                {/* 下载链接 */}
                <DownloadModal
                    downloadName = {downloadName}
                    downloadUrl = {downloadUrl}
                    onCancel={() => this.setState({ downloadModalVisible: false })}
                    visible={downloadModalVisible}>
                </DownloadModal>
            </Modal>
        )
    }
}
